<template>
  <div class="proposed-shipment-id phase-1">
    <InfoIcon
      v-for="error in errors"
      :key="error"
      icon="pi pi-exclamation-triangle"
      :tooltip="error"
      class="error"
    />

    <InfoIcon
      v-for="warning in warnings"
      :key="warning"
      icon="pi pi-exclamation-triangle"
      :tooltip="warning"
      class="warning"
    />

    {{ t('shipments.shipments') }} {{ proposedShipment.identifier }}
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useProposedShipmentValidations } from '@/composables/routeBuilder';
import { ProposedShipment } from '@/model/routeBuilder';

import InfoIcon from '@rygen/rygen-ui/components/ui/InfoIcon.vue';

const props = defineProps({
  proposedShipment: {
    type: Object as PropType<ProposedShipment>,
    required: true,
  },
});
const { proposedShipment } = toRefs(props);

const { t } = useI18n();
const { errors, validate, warnings } =
  useProposedShipmentValidations(proposedShipment);

defineExpose({
  validate,
});
</script>

<style>
.proposed-shipment-id.phase-1 {
  display: flex;
  gap: var(--sp-2);
  align-items: center;

  .info-icon-container {
    &.error {
      color: var(--danger-color);
    }

    &.warning {
      color: var(--warning-color);
    }
  }
}
</style>
